module.exports = __webpack_public_path__ + "img/birthday-1989.e08c1b0c.jpg";